import React from 'react';

interface IcoLikeProps {
    size?: number;
}

export const IcoLike: React.FC<IcoLikeProps> = ({ size = 16 }) => {
    const wrapperStyle: React.CSSProperties = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: `${size}px`,
        height: `${size}px`,
    };

    return (
        <div style={wrapperStyle}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width={size} height={size}>
                <g fill="none" opacity=".6">
                    <path
                        fill="#B8B8B8"
                        d="M2.341 5.878h1.415a1.06 1.06 0 0 1 1.06 1.057v7.048a1.06 1.06 0 0 1-1.06 1.057H2.34a1.06 1.06 0 0 1-1.061-1.057V6.935A1.06 1.06 0 0 1 2.34 5.878z"
                    />
                    <path
                        fill="#F1F1F1"
                        d="M10.718 15.04H6.232c-.782 0-1.415-.63-1.415-1.41V6.69c0-.522.194-1.026.545-1.415l1.736-1.921.268-1.609c.121-.724.987-1.032 1.55-.558.456.384.852.954.852 1.776 0 1.245-.707 2.915-.707 2.915h3.537c1.172 0 2.122.947 2.122 2.114v.94c0 .31-.069.616-.2.896l-1.88 3.995a2.122 2.122 0 0 1-1.922 1.217z"
                    />
                </g>
            </svg>
        </div>
    );
};
